module.exports = Jsw.skinUrl + "/images/blank.gif?56398e76be6355ad5999b262208a17c9";